var _path, _rect, _ellipse, _rect2, _rect3, _path2, _rect4, _ellipse2, _rect5, _rect6, _path3, _rect7, _ellipse3, _rect8, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAegHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 134,
    viewBox: "0 0 563 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H563V124.236H2V13Z",
    fill: "url(#paint0_radial_27_662)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 121.229,
    width: 400,
    height: 3.75796,
    fill: "url(#paint1_radial_27_662)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.072,
    cy: 123.016,
    rx: 10.0719,
    ry: 10.0159,
    fill: "url(#paint2_radial_27_662)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47308,
    width: 4.90692,
    height: 4.90692,
    transform: "matrix(0.707793 -0.70642 0.707793 0.70642 280.14 125.495)",
    stroke: "url(#paint3_linear_27_662)",
    strokeWidth: 4.90692
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709076,
    width: 2.89053,
    height: 2.89053,
    transform: "matrix(0.709076 -0.705132 0.709076 0.705132 283.499 123.516)",
    fill: "#EDDBAC",
    stroke: "url(#paint4_linear_27_662)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 118H561V9H0V118Z",
    fill: "url(#paint5_radial_27_662)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 5,
    transform: "matrix(1 0 0 -1 84 13)",
    fill: "url(#paint6_radial_27_662)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.0719,
    ry: 10,
    transform: "matrix(1 0 0 -1 284.072 10)",
    fill: "url(#paint7_radial_27_662)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47308,
    width: 4.90303,
    height: 4.90303,
    transform: "matrix(0.708355 0.705857 0.708355 -0.705857 278.139 7.52335)",
    stroke: "url(#paint8_linear_27_662)",
    strokeWidth: 4.90303
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709637,
    width: 2.88745,
    height: 2.88745,
    transform: "matrix(0.709637 0.704568 0.709637 -0.704568 281.5 9.50001)",
    fill: "#EDDBAC",
    stroke: "url(#paint9_linear_27_662)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 118H561V9H0V118Z",
    fill: "url(#paint10_radial_27_662)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 5,
    transform: "matrix(1 0 0 -1 84 13)",
    fill: "url(#paint11_radial_27_662)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.0719,
    ry: 10,
    transform: "matrix(1 0 0 -1 284.072 10)",
    fill: "url(#paint12_radial_27_662)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47308,
    width: 4.90303,
    height: 4.90303,
    transform: "matrix(0.708355 0.705857 0.708355 -0.705857 278.139 7.52335)",
    stroke: "url(#paint13_linear_27_662)",
    strokeWidth: 4.90303
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709637,
    width: 2.88745,
    height: 2.88745,
    transform: "matrix(0.709637 0.704568 0.709637 -0.704568 281.5 9.50001)",
    fill: "#EDDBAC",
    stroke: "url(#paint14_linear_27_662)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(282.117 124.236) rotate(-90) scale(55.9676 282.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4D41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286 123.108) rotate(90) scale(1.87898 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9F50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.072 123.016) rotate(90) scale(10.0159 10.0719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB9F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_662",
    x1: 9.53326,
    y1: -30.3685,
    x2: 2.59377,
    y2: 16.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_662",
    x1: 3.77929,
    y1: -12.0391,
    x2: 1.02826,
    y2: 6.53031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.117 9.00001) rotate(90) scale(54.8428 282.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4D41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200 2.5) rotate(90) scale(2.5 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9F50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0719 10) rotate(90) scale(10 10.0719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB9F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_27_662",
    x1: 9.52569,
    y1: -30.3444,
    x2: 2.59171,
    y2: 16.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_27_662",
    x1: 3.7763,
    y1: -12.0295,
    x2: 1.02744,
    y2: 6.52514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.117 9.00001) rotate(90) scale(54.8428 282.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4D41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200 2.5) rotate(90) scale(2.5 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9F50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_27_662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0719 10) rotate(90) scale(10 10.0719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB9F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_27_662",
    x1: 9.52569,
    y1: -30.3444,
    x2: 2.59171,
    y2: 16.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_27_662",
    x1: 3.7763,
    y1: -12.0295,
    x2: 1.02744,
    y2: 6.52514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAegHeader);
export default __webpack_public_path__ + "static/media/aeg-header.1fbe6b4c077903f6fa50672225640537.svg";
export { ForwardRef as ReactComponent };